export default __webpack_public_path__ + "movavi.fc8ef078.png";